/**
 * @generated SignedSource<<e686a717fb2b669638bd314074408f62>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivityVisibility = "AUTHENTICATED" | "MEMBERS" | "UNAUTHENTICATED";
export type LocationKind = "HYBRID" | "IN_PERSON" | "ONLINE";
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
import { DateTime } from "@/common/relayCustomScalar";
import { TimeZone } from "@/common/relayCustomScalar";
export type UpdateCompetitionInput = {
  about?: string | null | undefined;
  audience?: UpdateAudienceGroupsInput | null | undefined;
  banner?: any | null | undefined;
  description?: string | null | undefined;
  gettingStarted?: string | null | undefined;
  noCode?: boolean | null | undefined;
  privateApprovals?: boolean | null | undefined;
  purpose?: string | null | undefined;
  requiresApproval?: boolean | null | undefined;
  rewards?: ReadonlyArray<RewardInput> | null | undefined;
  rules?: string | null | undefined;
  scoringCriteria?: ReadonlyArray<UpdateCompetitionScoringCriterionInput> | null | undefined;
  shortDescription?: string | null | undefined;
  showMetric?: boolean | null | undefined;
  slug?: string | null | undefined;
  submissionDeadline?: DateTime | null | undefined;
  submissionPreamble?: string | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  templateWorkspaceVersionIds?: ReadonlyArray<string> | null | undefined;
  thumbnail?: any | null | undefined;
  timeline?: UpdateTimelineInput | null | undefined;
  title?: string | null | undefined;
  useJuryScore?: boolean | null | undefined;
  useLegacyDescription?: boolean | null | undefined;
  visibility?: ActivityVisibility | null | undefined;
};
export type UpdateCompetitionScoringCriterionInput = {
  description?: string | null | undefined;
  id?: string | null | undefined;
  title: string;
  weight: number;
};
export type UpdateTimelineInput = {
  endDate?: any | null | undefined;
  location?: LocationInput | null | undefined;
  startDate?: any | null | undefined;
  steps?: ReadonlyArray<TimelineStepInput> | null | undefined;
  timezone?: TimeZone | null | undefined;
};
export type TimelineStepInput = {
  date: any;
  label: string;
};
export type LocationInput = {
  city?: string | null | undefined;
  country?: string | null | undefined;
  kind: LocationKind;
};
export type RewardInput = {
  amount?: AmountRangeInput | null | undefined;
  description: string;
  kind: RewardKind;
};
export type AmountRangeInput = {
  end: number;
  start: number;
};
export type UpdateAudienceGroupsInput = {
  groups: ReadonlyArray<AudienceGroupInput>;
};
export type AudienceGroupInput = {
  items: ReadonlyArray<string>;
  label: string;
  position: number;
};
export type CompetitionRulesPageUpdateCompetitionMutation$variables = {
  id: string;
  input: UpdateCompetitionInput;
};
export type CompetitionRulesPageUpdateCompetitionMutation$data = {
  readonly updateCompetition: {
    readonly node: {
      readonly id: string;
      readonly latestRule: {
        readonly entityAgreement: {
          readonly createdAt: DateTime;
          readonly id: string;
        } | null | undefined;
        readonly id: string;
        readonly text: string;
      };
    };
  };
};
export type CompetitionRulesPageUpdateCompetitionMutation = {
  response: CompetitionRulesPageUpdateCompetitionMutation$data;
  variables: CompetitionRulesPageUpdateCompetitionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CompetitionEdge",
    "kind": "LinkedField",
    "name": "updateCompetition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionRuleAgreement",
                "kind": "LinkedField",
                "name": "entityAgreement",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionRulesPageUpdateCompetitionMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CompetitionRulesPageUpdateCompetitionMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "fd67f1e74ee08ba743b50f3e7563068b",
    "id": null,
    "metadata": {},
    "name": "CompetitionRulesPageUpdateCompetitionMutation",
    "operationKind": "mutation",
    "text": "mutation CompetitionRulesPageUpdateCompetitionMutation(\n  $id: ID!\n  $input: UpdateCompetitionInput!\n) {\n  updateCompetition(id: $id, input: $input) {\n    node {\n      id\n      latestRule {\n        id\n        text\n        entityAgreement {\n          id\n          createdAt\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9deb495f301bb4ffd8a4302a188cffd0";

export default node;
